import { Model } from ".";

export default class PricingHelpField extends Model {
	get singularNoun() {
		return "pricing help field";
	}

	resource() {
		return "pricing-fields";
	}
}
